import apiClient from "./interceptor"

export const getDoctorRetentionInfo = async (filter, format) => {
    try {
        const response = await apiClient.post(
            "/v2/users/users/myflexa-doctorRetention-dashboard",
            {
                timeline: filter,
                formatType: format
            }
        );
        return response;
    } catch (err) {
        console.log(err);
        return err;
    }
}